<template>
  <div class="element-box content-box">
    <div class="support-ticket-content">
      <div class="support-ticket-content-header mb-0">
        <a class="back-to-index" @click="regresarClick" style="color: green">
          <i class="os-icon os-icon-arrow-left5"></i>
          <span>Regresar</span>
        </a>
      </div>
    </div>
    <div class="floated-colors-btn second-floated-btn" style="z-index: 1010 !important" @click="cambiarUiTabla">
      <div class="os-toggler-w" :class="{ on: cambiar_UiTabla }">
        <div class="os-toggler-i">
          <div class="os-toggler-pill"></div>
        </div>
      </div>
      <span v-if="!cambiar_UiTabla">Tabla normal</span>
      <span v-if="cambiar_UiTabla">Tabla mini</span>
    </div>
    <div class="row mt-2">
      <div class="col-lg-12">
        <div class="padded-lg">
          <div class="ticket-content">
            <div style="text-align: center">
              <h5>
                Tarima #<b>{{ current.numero }}</b>
              </h5>
              <span class="badge" :class="{
                'badge-success': current.estado == 'A',
                'badge-dark': current.estado == 'C',
                'badge-danger': current.estado == '9',
              }">{{ current.estado_str }}</span>
            </div>
            <ModalAsignarProductosATarimaComponent :id_tarima="current.id" @refresh_tarima="refresh_tarima"
              @refresh_tarima_finalizada="regresarClick" />
            <div class="ticket-description">
              De: <b>{{ current.tienda_origen_obj.nombre }}</b>
              <br />
              Hacia: <b>{{ current.tienda_destino_obj.nombre }}</b>
              <br />
              Posición: <b>{{ current.posicion_estacion }}</b>
              <br />
              <span v-if="current.fecha_fin_carga">Fecha Finalización: <b>{{ current.fecha_fin_carga |
                moment("DD/MM/YYYY HH:MM") }} Hrs.</b></span>
              <br />
              <br />
              <div class="text-right">
                <button @click="refresh_tarima()" class="btn btn-sm btn-info">
                  Actualizar <i class="fas fa-sync"></i>
                </button>
              </div>
              <hr />
            </div>
          </div>
          <h6>Productos en Tarima:</h6>
          <br />
          <!--START - Projects list-->
          <div v-if="!cambiar_UiTabla" class="projects-list">
            <div class="project-box" v-for="detalle in current.detalle" :key="detalle.id"
              style="background-color: rgb(247, 241, 241)" @click="abrirModalDetalle(detalle)">
              <div class="project-head" style="padding-right: 1em; padding-left: 1em">
                <div class="project-title">
                  <h5>{{ detalle.producto_obj.sku }}</h5>
                  {{ detalle.producto_obj.nombre }}
                </div>
                <div class="badge badge-info" v-if="detalle.producto_obj.categoria">
                  {{ detalle.producto_obj.categoria.nombre }}
                </div>
                <br />
                <br />
                <div class="badge badge-default" v-for="_barra in detalle.producto_obj.barras" :key="_barra">
                  {{ _barra }}
                </div>
              </div>
              <div class="project-info">
                <div class="row align-items-center">
                  <div class="col-sm-12">
                    <div class="row">
                      <div class="col-6">
                        <div class="el-tablo highlight">
                          <div class="label">Total Enviada</div>
                          <h6 style="color: green">
                            {{ detalle.total_enviada }}
                          </h6>
                        </div>
                      </div>
                      <div class="col-6">
                        <div class="el-tablo highlight">
                          <div class="label">Total Recibida</div>
                          <h6 style="color: green">
                            {{ detalle.total_recibida }}
                          </h6>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!--END - Projects list-->
          <div v-if="cambiar_UiTabla">
            <table class="table table-hover">
              <thead>
                <tr>
                  <th></th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                <tr class="project-box" v-for="det in current.detalle" :key="det.id">
                  <td>
                    <div class="value">
                      <small class="font-weight-bold">{{ det.producto_obj.sku }}</small>
                    </div>
                    <small>
                      <div class="value">
                        {{ det.producto_obj.nombre }}
                      </div>
                    </small>
                    Total enviada:
                    <span class="sub-value font-weight-bold text-success">
                      {{ det.total_enviada }}
                    </span>
                  </td>
                  <td>
                    <div class="badge badge-info" v-if="det.producto_obj.categoria">
                      {{ det.producto_obj.categoria.nombre }}
                    </div>
                    <br />
                    Total Recibida:
                    <span class="sub-value font-weight-bold" style="color: blue">
                      {{ det.total_recibida }}
                      <i v-if="det.total_enviada == det.total_recibida" class="fas fa-check"></i>
                    </span>
                    <br />
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
      <ModalEntarimarComponent v-if="current.estado == 'A'" :tarima="current" @refresh_tarima="refresh_tarima" />
    </div>
    <!-- Modal -->
    <div class="modal fade" id="modalOpcionesDetalle" tabindex="-1" role="dialog" aria-labelledby="modalOpcionesDetalle"
      aria-hidden="true">
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="exampleModalLabel">Opciones</h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <div class="row">
              <div class="col-12">
                <button class="btn btn-danger btn-block" @click="deleteDetalle(detalle)">
                  Eliminar Linea
                </button>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" data-dismiss="modal">
              Close
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ModalEntarimarComponent from "@/components/wms/tarimas/ModalEntarimarComponent";
import ModalAsignarProductosATarimaComponent from "@/components/wms/tarimas/ModalAsignarProductosATarimaComponent";
import Notifications from "@/notifications/notifications";
import DynamicService from "@/services/commons/DynamicService";

export default {
  components: {
    ModalEntarimarComponent,
    ModalAsignarProductosATarimaComponent,
  },
  props: {
    current: {
      type: Object,
    },
  },
  data() {
    return { cambiar_UiTabla: false };
  },
  mounted() { },
  methods: {
    abrirModalDetalle(detalle) {
      this.detalle = detalle;
      $("#modalOpcionesDetalle").modal("show");
    },
    deleteDetalle(detalle) {
      let self = this;
      Notifications.alert.confirm(
        "Eliminar Linea",
        "¿esta seguro(a)?",
        "Si",
        function () {
          DynamicService.postAction(
            "wms",
            "tarima",
            self.current.id,
            "eliminar_detalle_tarima",
            {
              id: detalle.id,
            }
          )
            .then((response) => {
              Notifications.alert.success("Eliminar Linea", "Se realizó correctamente");
              $("#modalOpcionesDetalle").modal("hide");
              self.refresh_tarima();
            })
            .catch((error) => {
              Notifications.alert.error("Eliminar Linea", error.response.data.detail);
            });
        }
      );
    },
    cambiarUiTabla() {
      let self = this;
      self.cambiar_UiTabla = !self.cambiar_UiTabla;
    },
    regresarClick() {
      this.$emit("regresar");
    },
    refresh_tarima() {
      this.$emit("seleccionarTarima", this.current.id);
    },
  },
};
</script>
